import { useBrandTheme, useWidgetContext } from '@ptek/widget-core';
import { useEffect, useRef } from 'react';
import {
  buildWidgetConfigSnapshot,
  recordWidgetConfig,
} from '../config/dd-rum';
import { useWidgetAuth } from '../context/AuthContext';
import type { AmbientScribeContext } from '../types';

export const useWidgetConfigTelemetry = (): void => {
  const { isAuthenticated, user } = useWidgetAuth();
  const { widgetContext } = useWidgetContext<AmbientScribeContext>();
  const brand = useBrandTheme();

  const lastFeaturesSignature = useRef<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated || !user?.brand) return;

    const signature = JSON.stringify(widgetContext.context?.features ?? {});
    if (signature === lastFeaturesSignature.current) return;

    const snapshot = buildWidgetConfigSnapshot(
      widgetContext.context,
      user,
      brand?.brandName
    );
    recordWidgetConfig(snapshot);
    lastFeaturesSignature.current = signature;
  }, [isAuthenticated, user, widgetContext.context, brand?.brandName]);
};
